var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h1',{staticClass:"is-1"},[_vm._v(_vm._s(_vm.$t("hello")))]),_c('p',[_vm._v(_vm._s(_vm.$t("message")))])])}
var staticRenderFns = []

export { render, staticRenderFns }